import { Button, Divider, Stack, Typography, styled } from "@mui/material"
import {
  ButtonLink,
  FullWidthContent,
  FullWidthHeader,
  ListItemState,
  ROLES,
  type RoleStrategy,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { newsStatusesReferential } from "../../../commons"
import { News } from "../../../commons/NewsComponents/News"
import { NewsCreatorChip } from "../../components"
import { PostType } from "../../model"
import { ConfirmPublishNewsDialog } from "./ConfirmPublishNewsDialog"
import { CreatorChip } from "./CreatorChip"
import { useAdminNewsPreview } from "./useAdminNewsPreview"
import { usePublishAdminNewsPreview } from "./usePublishAdminNewsPreview"

export const AdminNewsPreview = () => {
  const navigate = useNavigate()
  const { id: newsId } = useParams()
  const { news, labsReferential, loading } = useAdminNewsPreview(newsId!)
  const { publishNews } = usePublishAdminNewsPreview(newsId!)
  const displayActions = useRoleConf(
    actionRoleConf(news?.status === "PENDING_REVIEW"),
  )
  const [openDialog, setOpenDialog] = useState(false)
  const onClickPublish = () => {
    setOpenDialog(true)
  }
  return (
    <FullWidthContent>
      {/* HEADER */}
      <FullWidthHeader
        title={
          <Stack direction="row" width="100%" alignItems="center" gap={2}>
            <Typography
              sx={{
                fontSize: "inherit",
                lineHeight: "inherit",
                fontWeight: "inherit",
                whiteSpace: "nowrap",
              }}
            >
              Aperçu de l’actualité
            </Typography>
            <NewsCreatorChip
              creatorType={news?.creatorType}
              laboratoryId={news?.laboratoryId}
              activeLaboratories={labsReferential}
              ChipElement={CreatorChip}
            />
          </Stack>
        }
        level={2}
        linkLabel="Retour à la liste"
        linkTo="../"
        rightElement={
          <Stack
            direction="row"
            gap={4}
            divider={<Divider flexItem orientation="vertical" />}
          >
            <ListItemState
              value={news?.status ?? ""}
              options={newsStatusesReferential}
            />

            <ButtonLink variant="contained" to={`../${news?.id}`}>
              Modifier
            </ButtonLink>
            {displayActions && (
              <Stack direction="row" gap={2}>
                <SuccessButton onClick={onClickPublish}>Publier</SuccessButton>
              </Stack>
            )}
          </Stack>
        }
      />

      {/* CONTENT */}
      <News
        newsLoading={loading}
        news={news}
        category={news?.postType === PostType.NEWS_POST ? news?.category : undefined}
      />

      {openDialog && news && (
        <ConfirmPublishNewsDialog
          news={news}
          onClickClose={() => {
            setOpenDialog(false)
          }}
          validateAction={() =>
            publishNews(undefined, {
              onSuccess: () => {
                navigate("../..")
              },
            })
          }
        />
      )}
    </FullWidthContent>
  )
}

const actionRoleConf = (canUpdateStatus: boolean): RoleStrategy<boolean> => ({
  [ROLES.ADMIN]: canUpdateStatus,
  [ROLES.UPP_PRESIDENT]: false,
  [ROLES.UPP_REPRESENTATIVE]: false,
})

const SuccessButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
}))
SuccessButton.defaultProps = {
  variant: "contained",
  color: "success",
}
